import React from "react";
import { ANALYZER_DIMENSIONS } from "./analyzerDimensions";
import FilterDropdown from "../../components/ui-components/FilterDropdown";

// dimensionOptions maps the curated dimension list to FilterDropdown's contract
// ({ value, label, disabled }), folding the unavailable-reason into the label so
// a disabled option still explains itself (e.g. "Environment (no data yet)").
export function dimensionOptions() {
  // Only offer dimensions that actually have data — unavailable ones (e.g. Environment,
  // no backing column yet) are dropped rather than shown as disabled placeholders.
  return ANALYZER_DIMENSIONS.filter((d) => d.available !== false).map((d) => ({
    value: d.id,
    label: d.label,
  }));
}

export default function GroupingSelect({ dimensionId, onChange, drillPath = [], onDrillUp }) {
  // Only perspective (owner-node) drills get the "All › …" breadcrumb: they add no
  // filter chip, so the breadcrumb is their only drill-up affordance. Flat-dimension
  // drills add a removable filter chip that already represents the drill, so the
  // breadcrumb would be a redundant duplicate — hide it. Node crumbs carry ownerNodeId;
  // flat crumbs carry { field, value }. Drill paths are homogeneous per dimension.
  const showBreadcrumb = drillPath.some((c) => c.ownerNodeId != null);
  return (
    <div className="flex items-center gap-3">
      <FilterDropdown
        ariaLabel="Breakdown"
        prefix="Breakdown:"
        value={dimensionId}
        onChange={onChange}
        minWidth={200}
        height={32}
        options={dimensionOptions()}
      />
      {showBreadcrumb && (
        <div className="flex items-center gap-1 text-sm">
          <button type="button" className="text-primary bg-transparent border-none p-0 cursor-pointer" onClick={() => onDrillUp(0)}>All</button>
          {drillPath.map((c, i) => {
            // Flat-dim crumbs are { field, value }; perspective crumbs are
            // { ownerNodeId, label } — always prefer an explicit label, fall
            // back to the flat dim's raw value.
            const text = c.label || c.value;
            const key = c.ownerNodeId != null ? `node:${c.ownerNodeId}` : `${c.field}:${c.value}`;
            return (
              <React.Fragment key={key}>
                <span className="text-text-3">›</span>
                {i < drillPath.length - 1
                  ? <button type="button" className="text-primary bg-transparent border-none p-0 cursor-pointer" onClick={() => onDrillUp(i + 1)}>{text}</button>
                  : <span className="font-medium text-text">{text}</span>}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}
